import React from 'react';

import CoreStepper from '@material-ui/core/Stepper';
import StepCore from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { StepIconProps } from '@material-ui/core/StepIcon';
import { StepIcon } from './StepItem';
import { StepItemConector } from './StepItemConnector';
import { useStyles } from './styles';

export type Step = {
  icon: React.ReactElement;
  label: string;
  error?: boolean;
};

export interface StepperProps {
  activeStep: number;
  steps: Step[];
}

export function Stepper({ activeStep, steps }: StepperProps) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CoreStepper
        alternativeLabel
        activeStep={activeStep}
        connector={<StepItemConector />}
      >
        {steps.map(({ icon, label, error }) => (
          <StepCore key={label}>
            <StepLabel
              error={error}
              StepIconComponent={(props: StepIconProps) => (
                <StepIcon iconElement={icon} error={error} {...props} />
              )}
            >
              {label}
            </StepLabel>
          </StepCore>
        ))}
      </CoreStepper>
    </div>
  );
}
